import { DialogTrigger } from '@components/ui/dialog'
import type React from 'react'

export default function ModalTrigger({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  return <DialogTrigger asChild>{children}</DialogTrigger>
}
